import PreviewFeedbackResult from '.';
import { RouteType } from '@/lib/route';

const PreviewFeedbackResultRoutes: RouteType = {
  path: '/preview-feedback/:elearningId/:type?',
  component: PreviewFeedbackResult,
};

export interface PreviewFeedbackResultParamType {
  elearningId: string;
  type?: string;
}

export default PreviewFeedbackResultRoutes;
